cv.ModalView = Marionette.LayoutView.extend({
  template: cv.Templates["global/modals/modal"],

  className: "modal-overlay",

  regions: {
    modal_content: ".modal-content",
  },

  events: {
    "click .modal-close": "hideModal",
  },

  childEvents: {
    // This callback will be called whenever a child is rendered or emits a `render` event
    show: _.bind(function () {
      // Update button Styles
      this.$(".button-primary").removeClass("-text-dark -text-light");
      this.$(".button-primary").addClass(
        cv.idealTextColor(this.$(".button-primary").css("background-color")),
      );
    }, this),
    render: function () {},
  },

  initialize: function (options) {
    this.options = _.extend(this.options, options);

    this.modal_count = 0;

    this.listenTo(vent, "modal:show", this.showModal, this);
    this.listenTo(vent, "modal:hide", this.hideModal, this);
    this.listenTo(vent, "modal:lock", this.lockModal, this);
    this.listenTo(vent, "modal:unlock", this.unlockModal, this);

    console.log("ModalView initialized");
  },

  lockModal: function () {
    this.$(".button").addClass("button-disabled");
  },

  unlockModal: function () {
    this.$(".button").removeClass("button-disabled");
  },

  hideModal: function (e) {
    if (!_.isUndefined(e)) {
      e.preventDefault();
    }

    setTimeout(
      _.bind(function () {
        this.modal_content.reset();
        vent.trigger("modal:after_hide");
      }, this),
      250,
    );
    this.$el.removeClass("modal-active");
  },

  showModal: function (view, options) {
    this.showChildView("modal_content", view);
    if (window.store) {
      window.store.dispatch("modal/hideModal");
    }

    if (!_.isUndefined(options)) {
      if (_.has(options, "hide_close") && options.hide_close == true) {
        this.$(".modal-close").remove();
      }
      if (_.has(options, "prevent_close") && options.prevent_close == true) {
        this.$(".modal-close, .modal-confirm").remove();
      }
    }

    vent.trigger("modal:after_show");
    this.$el.addClass("modal-active");

    this.modal_count++;
  },
});
